import React, { Component } from "react";
import cn from "classnames";
import { FormattedMessage } from "react-intl";

import Wrapper from "../../Wrapper";
import { isMobile, aspectRatio as ar } from "../../../../../common/parameters";

import Score from "../../../Score/score-display";
import Icon from "../../../../icon";
import { PlayBtn, Label } from "../common-style";

import NotEdited from "../Common/NotEdited";
import getBirdsPath from "../Common/getBirdsPath";
import { PagingButton } from "../../../Paging";
import play, { resetPlay } from "../Common/play";
import setUp from "../Common/setupNotation";
import { INotationThis } from "../Common/interfaces";

import {
    StyledEmbed,
    Pager,
    ScoreWrapper,
    ScorePositioner,
    Animation,
    VideoScreen1,
    Video1,
    VideoScreen2,
    Video2,
    VideoScreen3,
    Video3,
    VideoScreen4,
    Video4,
    VideoScreen5,
    Video5,
    VideoScreen6,
    EasterBackground,
    ChristmasBackground,
} from "./styles";
import messages from "./messages";

import { videoScreenCords, videoTransitionCords, scorePositions } from "./coordinates";
import { IProps, IState } from "./interfaces";

const vidY = 720;
const vidX = 1280;

class Flow extends Component<IProps, IState> {
    play = play.bind(this as unknown as INotationThis);
    setUp = setUp.bind(this as unknown as INotationThis);
    pauseOffset?: number;
    static defaultProps = {
        changeFlowPage: () => {},
        flowPage: null,
        handlePlayCount: () => {},
    };
    constructor(props: IProps) {
        super(props);
        this.state = {
            page: props.flowPage || 0,
            inTransition: false,
            scoreCurrentPos: scorePositions[props.flowPage || 0],
            playing: false,
            animationFirstPart: false,
            dir: 0,
            loaded: false,
            playingNote: [],
        };

        if (props.setReset) {
            props.setReset(this.resetTask);
        }
        if (props.saveState) {
            props.saveState(this.saveState);
        }
        if (props.restoreState) {
            props.restoreState(this.restoreState);
        }
        if (props.showSolution) {
            props.showSolution(this.showSolution);
        }
    }

    componentDidMount() {
        this.setUp();
        if (this.props.completed && this.props.task?.data?.scores?.length === 1) {
            setTimeout(() => {
                this.props.completed(this.props.task.type);
            }, 2000);
        }
        setTimeout(() => {
            this.setState({ loaded: true });
        }, 200);
    }

    componentDidUpdate = () => {
        if (this.props.flowPage !== null && this.props.flowPage !== undefined && this.props.flowPage !== this.state.page) {
            this.goToPageDirectly(this.props.flowPage);
        }
    };

    componentWillUnmount() {
        if (this.state.playing) {
            this.play();
        }
    }

    showSolution = () => {};

    resetTask = () => {};

    saveState = () => {
        return {
            page: this.state.page,
        };
    };

    restoreState = (state: IState) => {
        this.setState({
            page: state.page,
            scoreCurrentPos: scorePositions[state.page],
        });
    };

    goToPageDirectly = (page: number) => {
        setTimeout(() => {
            this.pauseOffset = 0;
        }, 500);
        this.setState({
            page,
            scoreCurrentPos: this.state.scoreCurrentPos.map((pos, index) => {
                return scorePositions[page][index];
            }),
            inTransition: true,
        });
        this.props.changeFlowPage!(page);
        setTimeout(() => {
            this.setState({ inTransition: false });
        }, 1000);
    };

    goPage = (dir: number) => {
        const { page } = this.state;
        const { isExperience } = this.props;
        const newPage = page + dir;
        setTimeout(() => {
            this.pauseOffset = 0;
        }, 500);
        if (isExperience) {
            this.setState({
                page: newPage,
                scoreCurrentPos: this.state.scoreCurrentPos.map((pos, index) => {
                    if (index === page) {
                        return scorePositions[newPage][index];
                    }
                    return pos;
                }),
                animationFirstPart: true,
                dir,
                inTransition: true,
            }, this.finishAnimation);
            return;
        }
        this.setState({
            page: newPage,
            scoreCurrentPos: this.state.scoreCurrentPos.map((pos, index) => {
                if (index === page) {
                    return scorePositions[newPage][index];
                }
                return pos;
            }),
            animationFirstPart: true,
            dir,
            inTransition: true,
        });
        this.props.changeFlowPage!(newPage);
        setTimeout(this.finishAnimation, 3500);
    };
    finishAnimation = () => {
        const { page } = this.state;
        this.setState({
            animationFirstPart: false,
            scoreCurrentPos: this.state.scoreCurrentPos.map((pos, index) => {
                if (index === page) {
                    return scorePositions[page][index];
                }
                return pos;
            }),
        });
        setTimeout(() => {
            this.setState({ inTransition: false });
            if (this.state.page === this.props.task.data.scores.length - 1) {
                if (this.props.completed) {
                    this.props.completed(this.props.task.type);
                }
            }
        }, 1000);
    };
    render() {
        const { task, preview, isExperience, isEaster, isChristmas, isExperienceCenter } = this.props;
        const {
            inTransition,
            animationFirstPart,
            page,
            scoreCurrentPos,
            playing,
            dir,
            loaded,
            playingNote,
        } = this.state;
        const {
            data,
            data: { sizes = [], scales = [], scores = [] },
        } = task;
        if (!data || !data.scores)
            return (
                <div>
                    <Wrapper>
                        <NotEdited />
                    </Wrapper>
                </div>
            );
        const maxPage = data.scores.length - 1;
        return (
            <Wrapper isFlow isExperienceCenter={isExperienceCenter}>
                <StyledEmbed isExperience={!!isExperience}>
                    <Animation
                        style={{
                            transform: `translate(${
                                (animationFirstPart
                                    ? videoTransitionCords[page + (dir === -1 ? 1 : 0)]!.x
                                    : videoScreenCords[page].x) * -vidX
                            }px ,${
                                (animationFirstPart
                                    ? videoTransitionCords[page + (dir === -1 ? 1 : 0)]!.y
                                    : videoScreenCords[page].y) * -vidY
                            }px)`,
                            ...(!loaded && {
                                transition: "0s",
                            }),
                        }}
                    >
                        {page <= 1 && !isExperience && (
                            <VideoScreen1 autoPlay playsInline muted loop>
                                <source src={getBirdsPath("/flow/summer-screen-1.mp4")} />
                            </VideoScreen1>
                        )}
                        {!preview && !isExperience && (
                            <>
                                {page <= 1 && maxPage > 0 && (
                                    <Video1 autoPlay playsInline muted loop>
                                        <source src={getBirdsPath("/flow/summer-1.mp4")} />
                                    </Video1>
                                )}
                                {page >= 0 && page <= 2 && maxPage > 0 && (
                                    <VideoScreen2 autoPlay playsInline muted loop>
                                        <source src={getBirdsPath("/flow/summer-screen-2.mp4")} />
                                    </VideoScreen2>
                                )}

                                {page >= 1 && page <= 2 && maxPage > 1 && (
                                    <Video2 autoPlay playsInline muted loop>
                                        <source src={getBirdsPath("/flow/summer-2.mp4")} />
                                    </Video2>
                                )}

                                {page >= 1 && page <= 3 && maxPage > 1 && (
                                    <VideoScreen3 autoPlay playsInline muted loop>
                                        <source src={getBirdsPath("/flow/summer-screen-3.mp4")} />
                                    </VideoScreen3>
                                )}
                                {page >= 2 && page <= 3 && maxPage > 2 && (
                                    <Video3 autoPlay playsInline muted loop>
                                        <source src={getBirdsPath("/flow/summer-3.mp4")} />
                                    </Video3>
                                )}
                                {page >= 2 && page <= 4 && maxPage > 2 && (
                                    <VideoScreen4 autoPlay playsInline muted loop>
                                        <source src={getBirdsPath("/flow/summer-screen-4.mp4")} />
                                    </VideoScreen4>
                                )}
                                {page >= 3 && page <= 4 && maxPage > 3 && (
                                    <Video4 autoPlay playsInline muted loop>
                                        <source src={getBirdsPath("/flow/summer-4.mp4")} />
                                    </Video4>
                                )}
                                {page >= 3 && maxPage > 3 && (
                                    <VideoScreen5 autoPlay playsInline muted loop>
                                        <source src={getBirdsPath("/flow/summer-screen-5.mp4")} />
                                    </VideoScreen5>
                                )}
                                {page >= 4 && maxPage > 4 && (
                                    <Video5 autoPlay playsInline muted loop>
                                        <source src={getBirdsPath("/flow/summer-5.mp4")} />
                                    </Video5>
                                )}
                                {page >= 4 && maxPage > 4 && (
                                    <VideoScreen6 autoPlay playsInline muted loop>
                                        <source src={getBirdsPath("/flow/summer-screen-6.mp4")} />
                                    </VideoScreen6>
                                )}
                            </>
                        )}
                    </Animation>
                    {scores.map((score, index) => (
                        <ScorePositioner
                            key={index}
                            style={{
                                transform: `translate(${scoreCurrentPos[index][0] * 1280 * 1.5}px, ${
                                    scoreCurrentPos[index][1] * 720 * 1.5
                                }px)`,
                                ...(!loaded && {
                                    transition: "transform 0s",
                                }),
                            }}
                        >
                            {isEaster && (
                                <EasterBackground
                                    style={{
                                        top: (200 - (sizes[index]?.y || 120)),
                                        bottom: (200 - (sizes[index]?.y || 120)),
                                        width: (sizes[index]?.x || 0.8) * ar.width,
                                        left: (ar.width - ar.width * (sizes[index]?.x || 0.8)) / 2,
                                        transform: `scale(1.15, ${(sizes[index]?.x || 0.8) * 1.15})`,
                                    }}
                                />
                            )}
                            {isChristmas && (
                                <ChristmasBackground
                                    style={{
                                        top: (200 - (sizes[index]?.y || 120)),
                                        bottom: (200 - (sizes[index]?.y || 120)),
                                        width: (sizes[index]?.x || 0.8) * ar.width,
                                        left: (ar.width - ar.width * (sizes[index]?.x || 0.8)) / 2,
                                        transform: `scale(1, ${(sizes[index]?.x || 0.8)})`,
                                    }}
                                />
                            )}
                            <ScoreWrapper
                                style={{
                                    transform: `scale(${sizes[index]?.x || 0.8})`,
                                    top: 200 - (sizes[index]?.y || 120),
                                    bottom: 200 - (sizes[index]?.y || 120),
                                    ...((isEaster || isChristmas) && {
                                        backgroundColor: "transparent",
                                        borderColor: "transparent",
                                    }),
                                }}
                            >
                                <Score
                                    score={score}
                                    scale={scales[index] || 1}
                                    playingNote={page === index ? playingNote : []}
                                    playing={page === index ? playing : false}
                                />
                            </ScoreWrapper>
                        </ScorePositioner>
                    ))}
                    <Pager style={{ opacity: inTransition || playing ? 0 : 0.6 }}>
                        <PagingButton
                            as="button"
                            className={cn("button", "button--light")}
                            onClick={() => {
                                if (playing) return;
                                if (!inTransition) this.goPage(-1);
                            }}
                            disabled={page === 0}
                        >
                            <Icon i="arrowback" />
                        </PagingButton>
                        <PagingButton
                            as="button"
                            className={cn("button", "button--light", "Flip")}
                            onClick={() => {
                                if (playing) return;
                                if (!inTransition) this.goPage(1);
                            }}
                            disabled={page === scores.length - 1}
                        >
                            <Icon i="arrowback" />
                        </PagingButton>
                    </Pager>
                    <PlayBtn
                        isEaster={isEaster}
                        resetPlay={this.pauseOffset && !playing ? resetPlay.bind(this as unknown as INotationThis) : undefined}
                        className={cn("button", "button--play")}
                        style={{
                            opacity: isExperience ? 1 : (inTransition ? 0 : 0.8),
                            ...(!isExperience && {
                                top: 20,
                                left: 20,
                            }),
                            transition: "background-color 0.3s, opacity 1000ms",
                        }}
                        onClick={() => {
                            if (inTransition) return;
                            if (isMobile) return;
                            this.play();
                        }}
                        onTouchStart={() => {
                            if (inTransition) return;
                            if (isMobile) this.play();
                        }}
                    >
                        {playing ? <Icon i="pause" /> : <Icon i="play" />}
                        <Label>
                            <FormattedMessage {...messages.play} />
                        </Label>
                    </PlayBtn>
                </StyledEmbed>
            </Wrapper>
        );
    }
}

export default Flow;
